<ada-header
	[activeProduct$]="activeProduct$"
	[dropdownMenu]="Menu"
	[getProductNames]="licenseManager.getUserFriendlyProductName | adaBindMethod: licenseManager"
	[productNavigation$]="productNavigation$"
	[user$]="auth.user"
	(signout)="logout()"
>
	@if (aida.isEnabled()) {
		<div
			class="ada-container ada-flex-align-center ada-text-align-center llm-button-wrapper"
			data-container-selector="ada-header-controls"
		>
			@let _displayText = `Ask ${aida.displayName()}`;
			@let _isSuperAdmin = isSuperAdmin();

			@if (!_isSuperAdmin) {
				<ada-signpost
					buttonLook="solid"
					iconColor="onPrimary"
					[style.margin-right]="ui.Spacing.SPACING_MEDIUM"
				>
					<ada-text content="Aida is only accessible to Super Admin accounts" />
				</ada-signpost>
			}

			<button
				class="ada-btn ada-btn-icon ada-btn-solid ada-btn-no-margin"
				data-testid="header-llm-button"
				[attr.aria-label]="_displayText"
				[attr.disabled]="!_isSuperAdmin || null"
				[attr.title]="_displayText"
				(click)="aida.isOpen.set(true)"
			>
				<ada-icon icon="faSparkles" />
				{{ _displayText }}
			</button>
		</div>
	}
</ada-header>
<ada-menu
	#Menu
	[closeOnSelection]="true"
	[controller]="menuController"
/>
